// 待支付
export const OrderNeedPay = 1;
// 待审核
export const OrderNeedAssess = 2;
// 已付款
export const OrderPayed = 3;
// 已接单
export const OrderHasReceived = 4;
// 待配送
export const OrderNeedSend = 5;
// 待自提
export const OrderNeedTake = 6;
// 待取餐
export const OrderNeedCatch = 7;
// 配送中
export const OrderIsSending = 8;
// 已送达
export const OrderHasArrivals = 9;
// 已评价
export const OrderHasComment = 10;
// 已取消
export const OrderCancel = 11;
// 已拒单
export const OrderReject = 12;
// 退款中
export const OrderRefunding = 13;
// 退款成功
export const OrderRefundSuccess = 14;
// 退款失败
export const OrderRefundError = 15;
